import { useEffect, useState } from 'react';
export const useDebouncedValue = (value, delay = 300) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => clearTimeout(id);
    }, [value]);
    return debouncedValue;
};
